<template>
  <v-app id="main">
    <!-- TODO: seems to never show this block? repeated in statemap -->
    <div v-show="loggedIn === null" :class="{ loader: true }">
      <v-row align="center" justify="center" class="pa-12">
        <v-img
          src="@/assets/assuresrv_logo_terracotta.png"
          max-width="300px"
          alt="Assure cloud"
        />
      </v-row>

      <v-row align="center" justify="center" class="pa-12">
        <v-progress-circular size="100" indeterminate color="primary" />
      </v-row>
    </div>
    <router-view />
    <NotificationsManager />
  </v-app>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { readIsLoggedIn, readSSOLoggedIn } from "@/store/main/getters";
import {
  dispatchCheckLoggedIn,
  dispatchLogOut,
  dispatchRefreshSSOToken,
  dispatchGetOauthConfig,
} from "@/store/main/actions";
import NotificationsManager from "@/components/NotificationsManager.vue";
import axios from "axios";
import { initMsalAndHandleRedirect } from "@/msal";

@Component({
  components: { NotificationsManager },
})
class App extends Vue {
  refreshIntervalId: number | undefined = undefined;

  // tokenRefreshTimout: ReturnType<typeof setTimeout> | null = null;
  loggedIn(): boolean | null {
    return readIsLoggedIn(this.$store);
  }

  private async refreshLoopTick(): Promise<void> {
    // must be logged in
    if (!readIsLoggedIn(this.$store)) {
      console.log("[auth] not logged in");
      return;
    }
    // only for SSO
    if (!readSSOLoggedIn(this.$store)) {
      console.log("[auth] not sso");
      return;
    }
    // this will log you out if refresh is unsuccessful
    console.log("[auth] periodic refresh tick successful -> refreshing");
    await dispatchRefreshSSOToken(this.$store);
  }

  logout(): void {
    dispatchLogOut(this.$store);
  }

  async created(): Promise<void> {
    axios.defaults.withCredentials = true;
    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
      },
      function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (error?.response?.status && error.response.status === 401) {
          console.log("Got 401, logging out");
          // Force the user to log in again immediately
          setTimeout(() => {
            // Reload the page to force a re-login
            window.location.reload();
          }, 0);
        }
        return Promise.reject(error);
      },
    );
    await dispatchCheckLoggedIn(this.$store);

    await dispatchGetOauthConfig(this.$store);

    // initialise msal instance
    await initMsalAndHandleRedirect(this.$store);

    // check every 10 seconds (extend this later) whether access token can be refreshed
    // TODO: logic to make this only sso, or extend to non sso if needed
    // TODO: make it so that it only extends when it's closer to expiring
    // void this.refreshLoopTick();
    // this.refreshIntervalId = window.setInterval(() => {
    //   void this.refreshLoopTick();
    // }, 10000);
  }

  beforeUnmount(): void {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = undefined;
    }
  }
}
export default toNative(App);
</script>

<style>
.loader {
  z-index: 2022;
  bottom: 0;
  color: white;
  display: block;
  font-size: 32px;
  left: 0;
  overflow: hidden;
  padding-top: 10vh;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
}

/*
bootstrap's _reboot.scss is overriding the margin-bottom with .5rem
which offsets checkbox labels
*/
label {
  margin-bottom: 0;
}
</style>
